module.exports = __webpack_public_path__ + "static/img/patent34.0b17b88c.png";